// Actions
export const PROJECT_FETCH  = '[Project] Fetch'

// Mutations
export const PROJECT_META   = '[Project] meta'
export const PROJECT_OBTAIN = '[Project] obtain'
export const PROJECT_CLEAR  = '[Project] clear'
export const PROJECT_SET_LOADING = '[Project] set loading'
